import { useAppRouter } from "@phonero/common-ux"
import { routes } from "../routes"

export function useAppRouterDP() {
  return useAppRouter(routes)
}
